import React from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FormField from "./FormField";
import { SortableContainer, arrayMove } from "react-sortable-hoc";
import { useSelector, useDispatch } from "react-redux";
import { setFormFields } from "redux/actions/FormBuilder";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1rem",
  },
  divider: {
    marginBlock: "16px",
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
  container: {
    padding: "16px",
  },
  editButton: {
    marginRight: "16px",
  },
}));
const ItemsList = SortableContainer(({ allItems }) => {
  return (
    <Box width={"100%"}>
      {allItems.map((item, index) => (
        <FormField item={item} index={index} itemIndex={index} key={item.id || `item-${index}`} />
      ))}
    </Box>
  );
});

const FormFields = () => {
  const classes = useStyles();
  const { formFields = [] } = useSelector(({ formBuilder }) => formBuilder);
  const dispatch = useDispatch();

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const reorderedFields = arrayMove([...formFields], oldIndex, newIndex);
    dispatch(setFormFields(reorderedFields));
  };

  return (
    <Box className={classes.root}>
      <Typography variant="h2" color="textSecondary">
        فیلد ها ({formFields.length})
      </Typography>
      <Divider className={classes.divider} />
      <ItemsList allItems={formFields} onSortEnd={onSortEnd} useDragHandle />
      {formFields.length === 0 && (
        <Box display={"flex"} justifyContent={"center"} marginY={"48px"}>
          <Typography color="textSecondary">موردی را انتخاب نمایید</Typography>
        </Box>
      )}
    </Box>
  );
};

export default FormFields;
